export const MAX_CAMPAIGN_DURATION_DAYS = 28;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export function nowEpochMs() {
    return Date.now();
}
export function yesterdayEpochMs() {
    return (nowEpochMs() - ONE_DAY_MS);
}
export function tomorrowEpochMs() {
    return (nowEpochMs() + ONE_DAY_MS);
}
export function startOfUtcDay(date) {
    const copy = new Date(date);
    copy.setUTCHours(0, 0, 0, 0);
    return copy;
}
export function endOfUtcDay(date) {
    const copy = new Date(date);
    copy.setUTCHours(23, 59, 59, 999);
    return copy;
}
export function validateCampaignDuration(startDate, endDate) {
    if (!startDate || !endDate) {
        return { valid: true };
    }
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (end < start) {
        return { valid: false, message: "End date must be after start date" };
    }
    const durationMs = end.getTime() - start.getTime();
    const durationDays = Math.ceil(durationMs / (1000 * 60 * 60 * 24));
    if (durationDays > MAX_CAMPAIGN_DURATION_DAYS) {
        return {
            valid: false,
            message: `Campaign duration cannot exceed ${MAX_CAMPAIGN_DURATION_DAYS} days. Current duration: ${durationDays} days`,
            durationDays,
        };
    }
    return { valid: true, durationDays };
}
export function timestampToIso(value) {
    if (!value)
        return null;
    if (typeof value.toDate === "function") {
        return value.toDate().toISOString();
    }
    const date = typeof value === "number"
        ? new Date(value)
        : value instanceof Date
            ? value
            : typeof value === "string"
                ? new Date(value)
                : value.toDate
                    ? value.toDate()
                    : new Date(NaN);
    const time = date.getTime();
    return Number.isFinite(time) ? date.toISOString() : null;
}
